export type SvgEl = React.HTMLAttributes<HTMLOrSVGElement>;

export const IconAvatar: React.FC<SvgEl> = (props: SvgEl) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
      <path d="M40 19.1A15.8 15.8 0 1055.9 35 15.8 15.8 0 0040.1 19zM40 0a40 40 0 1040 40A40 40 0 0040 0zm27.4 65.5a32.6 32.6 0 00-54.7 0 37.4 37.4 0 1154.7 0z" />
    </svg>
  );
};
